// extracted by mini-css-extract-plugin
export default {"aboutMe":"AboutMe_aboutMe__ewN5X","container":"AboutMe_container__vDel7"};